export default __webpack_public_path__ + "static/media/markerNiku.b40704fe.png";